import {Injectable} from '@angular/core';
import {DiagramUpdateService} from '../../diagram-data/diagram-update.service';
import {ShapeSpawnerService} from '../../diagram-render/shapes/shape-spawner.service';
import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {ConnectorCreateCommand} from './connector.create.command';
import {FlowlineAssociationService} from '../../core/services/flowline-association.service';
import {ConnectorDeleteCommand} from './connector.delete.command';
import {AngularComponentService} from '../../diagram-render/mx-graph/graph/angular-component.service';
import {ChangeConTermStyleCommand} from './change-con-term-style.command';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';

@Injectable()
export class ConnectorCommands {
  private serviceObj: object;

  constructor(
    diagramUpdateSvc: DiagramUpdateService,
    shapeSpawnerSvc: ShapeSpawnerService,
    editorRegistrySvc: EditorRegistryService,
    graphHelperSvc: GraphHelperService,
    flAssocSvc: FlowlineAssociationService,
    angularCompSvc: AngularComponentService,
    diagramJsonSvc: DiagramJsonHandlerService
  ) {
    this.serviceObj = {
      diagramUpdateSvc,
      shapeSpawnerSvc,
      editorRegistrySvc,
      graphHelperSvc,
      flAssocSvc,
      angularCompSvc,
      diagramJsonSvc
    };
  }

  public create(data: ConnectorJson, type: 'connector' | 'terminator') {
    return new ConnectorCreateCommand(data, type).injectServices(this.serviceObj);
  }

  public delete(data: ConnectorJson, type: 'connector' | 'terminator') {
    return new ConnectorDeleteCommand(data, type).injectServices(this.serviceObj);
  }

  public changeStyle(data: ConnectorJson, type: 'connector' | 'terminator') {
    return new ChangeConTermStyleCommand(data, type)
      .injectServices(this.serviceObj)
      .prepareData(data);
  }
}

export interface ConnectorJson {
  flowlineMxKey: string | number;
  [name: string]: any;
  style?: any;
  customStyle?: any;
}
